import React, { useMemo } from 'react'

import { useTranslation } from '@lib/i18n'

interface JourneyListTitleProps {
  twoWayConnections: boolean
  outbound?: Connection | null
}

const JourneyListTitle = ({ twoWayConnections, outbound }: JourneyListTitleProps) => {
  const { t } = useTranslation()

  const title = useMemo(() => {
    if (twoWayConnections && !outbound) return t('journeyList.outboundTrip')
    if (twoWayConnections && outbound) return t('journeyList.inboundTrip')

    return t('journeyList.trip')
  }, [twoWayConnections, outbound, t])

  return <>{title}</>
}

export default JourneyListTitle
